var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"crowded-banking-page"},[_c('iframe',{staticClass:"crowded-banking-iframe",attrs:{"src":_vm.iframeSrc,"allowpaymentrequest":"","allow":"payment *","referrerpolicy":"no-referrer"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }